import { useImageLoadError } from "ui/src/components/UniversalImage/hooks/useImageLoadError";
import { UniversalImageResizeMode } from "ui/src/components/UniversalImage/types";
import { Flex } from "ui/src/components/layout/Flex";
import { isTestEnv } from "utilities/src/environment/env";
export function PlainImage({ uri, size, fallback, resizeMode, style, testID, onLoad }) {
  const { hasError, markErrored } = useImageLoadError(uri);
  const objectFit = resizeMode === UniversalImageResizeMode.Contain || resizeMode === UniversalImageResizeMode.Cover ? resizeMode : "contain";
  const imgElement = <img
    key={uri}
    height={size.height}
    src={uri}
    style={{ objectFit, aspectRatio: size.aspectRatio, ...style }}
    width={size.width}
    onError={() => {
      markErrored();
    }}
    onLoad={onLoad}
  />;
  if (hasError && fallback) {
    return fallback;
  }
  if (isTestEnv()) {
    return <Flex testID={testID}>{imgElement}</Flex>;
  } else {
    return imgElement;
  }
}
